<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="标签名称">
            <a-input v-decorator="['tagName',rules.tagName ]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="标签类型">
            <a-select
                :allowClear="true"
                v-decorator="['tagTypeId',rules.tagTypeId]"
                :options="tagType"
                @change="changeType"
                :disabled="show"
            >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <!--      todo 之前手动输入分组名 改为标签分组下拉 -->
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="标签分组">
            <a-select
                :allowClear="true"
                v-decorator="['tagGroupId',rules.tagGroupId]"
                :options="groupTwoList"
                @change="changeGroupType"
                :disabled="show"
            >
            </a-select>
            <!--            <a-input v-decorator="['tagGroupId',rules.tagGroupId ]"-->
            <!--                     :disabled="show"/>-->
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//接口API
import {dataApi} from '@/services/client/labelManage';

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    tagName: {
      rules: [{required: true, whitespace: true, message: "请输入标签名称"}]
    },
    tagTypeId: {
      rules: [{required: true, message: "请选择标签类型"}]
    },
    tagGroupId: {
      rules: [{required: true, message: "请选择标签分组"}]
    },
  };
}

function newEntity() {
  // 点击了标签分组时 显示默认值
  let tagGroupId, tagTypeId
  if (this.selectedObj) {
    if (this.selectedObj.parentId === 0) {
      tagTypeId = this.selectedObj.groupId
      tagGroupId = null
      this.getTwoListFunc(this.selectedObj.groupId);
    } else {
      // 修改v-decorator的值
      tagTypeId = this.selectedObj.parentId
      tagGroupId = this.selectedObj.groupId

      this.getTwoListFunc(this.selectedObj.parentId);
    }
  }
  return {
    tagTypeId: tagTypeId,
    tagGroupId: tagGroupId
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  await this.getTwoListFunc(entity.data.tagTypeId);
  this.show = true;
  return fmt.formatFormLoad(entity);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  delete entities.tagTypeName
  delete entities.tagGroupName
  entities.tagId = vm.keyId; //更新
  return await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['selectedObj'],
  data() {
    return {
      show: false,
      weichatTagGroupId: "",
      weichatTagId: "",
      editStatus: false,
      treeData: [],
      dealer: [],
      tagType: [{title: '企微标签', value: 1}, {title: 'SCRM标签', value: 2}],
      groupTwoList: [],
      tagGroupName: ''
    }
  },
  mounted() {

  },
  methods: {
    newEntity,
    loadEntity,
    save,
    getRulesTemplate,
    async changeType(val) {
      this.getTwoListFunc(val)
      if (val === 2) {
        this.rules.tagGroupId.rules[0].required = true
      } else {
        this.rules.tagGroupId.rules[0].required = false
      }
      this.form.setFieldsValue({
        tagGroupId: null
      })
    },
    async changeGroupType(val) {
      console.log(val)
    },
    async getTwoListFunc(val) {  //获取二级标签分组
      let tagList = await dataApi.getTagTwoList(val);
      this.groupTwoList = tagList.data.map(item => {
        return {
          label: item.groupName,
          title: item.groupName,
          value: item.groupId
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
</style>